var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.12 13.41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M1.41 13.41L0 12l5.29-5.29L0 1.41 1.41 0l6.71 6.71-6.71 6.7z"
  })));
}

export default SvgChevronRight;